import { render, staticRenderFns } from "./RouteFooter.vue?vue&type=template&id=391e252e&lang=html&"
import script from "./RouteFooter.vue?vue&type=script&lang=js&"
export * from "./RouteFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports